<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">Patsy was born, Margaret Stone on 4<sup>th</sup> of April. Her due date should have been 17<sup>th</sup> March, St Patricks Day and Patsy was he Father’s pet name for her.</p>
<p style="text-indent:00em; padding-top:15px;">Patsy was a real Dundee lass. She worked in the office of the local jute mill as a wages clerk. In those days long before computers. Her means of calculating wages and bonuses was with a slide rule.</p>
<p style="text-indent:00em; padding-top:15px;">When Patsy, a working mother with 5 children, was finally able to pursue her love of writing, her husband, Andy, proudly presented her with her first laptop.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?7e742c60